#ifdef USE_TANGENT

vn = normal;
vt = tangent;

#endif
